module.exports = __webpack_public_path__ + "static/media/Portrait-10043.773f547e.jpg";